import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectAccountFeature } from 'reducers/account/features';

import { EVENT_ANALYTICS, SAVED_CHARTS } from 'constants/features';

import NavbarLink from 'components/App/Navbar/NavbarLink';
import NavbarSection from 'components/App/Navbar/NavbarSection';

const WebNavItems = ({ eventAnalyticsEnabled, savedChartsEnabled }) => (
  <>
    <NavbarSection>
      <NavbarLink icon="map" href="/flows">
        Flows
      </NavbarLink>
      <NavbarLink icon="check-circle" href="/checklists">
        Checklists
      </NavbarLink>
      <NavbarLink icon="comment-alt" href="/nps">
        NPS
      </NavbarLink>
    </NavbarSection>

    <hr />

    {eventAnalyticsEnabled && (
      <>
        <NavbarSection>
          <NavbarLink icon="chart-bar" href="/insights/explorer">
            Events Explorer
          </NavbarLink>
          {savedChartsEnabled && (
            <NavbarLink icon="th" href="/insights/charts">
              Dashboard
            </NavbarLink>
          )}
        </NavbarSection>
        <hr />
      </>
    )}

    <NavbarSection>
      <NavbarLink icon="palette" href="/themes">
        Themes
      </NavbarLink>
      <NavbarLink icon="users" href="/segments">
        Segments
      </NavbarLink>
      <NavbarLink icon="bullseye" href="/goals">
        Goals
      </NavbarLink>
    </NavbarSection>
  </>
);

WebNavItems.propTypes = {
  eventAnalyticsEnabled: PropTypes.bool,
  savedChartsEnabled: PropTypes.bool,
};

const mapStateToProps = state => ({
  eventAnalyticsEnabled: selectAccountFeature(state, EVENT_ANALYTICS),
  savedChartsEnabled: selectAccountFeature(state, SAVED_CHARTS),
});

export default connect(mapStateToProps)(WebNavItems);
